<template>
  <!-- 模板 -->
  <div class="container">
    <div class="top clearfix">
      <div class="top-left col-xs-12 col-sm-5">
        <img src="../assets/image/pan.png" alt="">
        <span><slot name="left"></slot></span>
      </div>

      <div class="top-right col-xs-12 col-sm-7 none-padding">
        <ul>
          <slot name="right"></slot>
        </ul>
      </div>
    </div>
    <!-- <div class="the-hr" ></div> -->
    <!-- <hr> -->

    <div class="content clearfix">
      <div class="col-xs-12" style="padding:0px;">
        <slot name="banner"></slot>
      </div>
      <div class="col-xs-12 content-left">
        <slot name="content"></slot>

      </div>
      <!--<div class="col-xs-12 col-sm-4 content-right">-->
        <!--<slot name="the-right">-->
          <!--<div class="col-xs-12">-->
            <!--<span class="news-title">滙業盃專區</span>-->
            <!--<div class="transverse-line"></div>  &lt;!&ndash; 綠色橫線 &ndash;&gt;-->
          <!--</div>-->
          <!--<div class="col-xs-6 img-btn">-->
            <!--<router-link to="/huiye" class="router-style">-->
              <!--<img class="singup" src="../assets/image/singup.png">-->
              <!--<div class="download-btn">網上報名</div>-->
            <!--</router-link>-->
          <!--</div>-->
          <!--<div class="col-xs-6 img-btn">-->
            <!--<router-link to="/download" class="router-style">-->
              <!--<img class="download" src="../assets/image/download.png">-->
              <!--<div class="download-btn">下載表格</div>-->
            <!--</router-link>-->
          <!--</div>-->
          <!--&lt;!&ndash; 線上問答比賽 &ndash;&gt;-->
          <!--<div class="col-xs-12 right-img">-->
            <!--<router-link to="/common-sense">-->
              <!--<img class="online-compet" src="../assets/image/online_competition.png">-->
            <!--</router-link>-->
          <!--</div>-->
          <!--<div v-for="(activity) in activitys" :key="activity.id" class="col-xs-12 right-img">-->
            <!--<router-link :to="{path: 'activity-rules', query: {id:activity.id}}">-->
              <!--<img class=" online-compet" :src="activity.thumbnail_url">-->
            <!--</router-link>-->
          <!--</div>-->
        <!--</slot>-->
      <!--</div>-->

    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      activitys: []
    }
  },
  methods: {
    // 获取所有的活动
    getAllActivity: function () {
      var that = this
      this.$axios.get('/activity/name')
        .then(function (response) {
          that.activitys = response.data.data
          // console.log(that.activitys)
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  },
  mounted () {
    this.goTop()
    this.getAllActivity()
  }
}
</script>
<style scoped>
  .container {
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
    border-radius: 5px;
    margin-top: 60px;
    /*min-height: 900px;*/
    padding-right: 0px;
  }

  .container hr {
    margin-top: 0px;
    height: 5px;
    background: #617BE4;
  }

  .top {
    font-family: PingFangSC-Medium;
    color: #565656;
    border-bottom: 5px solid #617BE4;
    padding: 5px 0;
    /*margin-bottom: 10px;*/
  }

  .top .top-left {
    display: inline-block;
    margin-top: 8px;
    padding-bottom: 8px;
    padding-left: 25px;
  }

  .top .top-left img {
    margin-bottom: 5px;
  }

  .top .top-left span {
    font-size: 24px;
  }

  .top .top-right {
    text-align: right;
    margin-top: 10px;
  }

  .top .top-right ul{
    padding-left: 0px;
    margin-right: 20px;
  }

  .top ul li {
    display: inline-block;
    font-size: 20px;
  }

  .top ul li a {
    border: 2px solid rgba(0,0,0,0);
    padding: 2px 15px;
    /*padding: 0px 5px;*/
    color: #565656;
  }

  .top ul li a:hover, .top ul li a:focus {
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }
  .top .is-check{
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }

  .content .content-left {
    min-height: 300px;
    margin-bottom: 40px;
    margin-top: 30px;
    font-size: 16px;
    border-right: 1px solid #DCDEE1;
  }

  /*@media (min-width: 1400px) {*/
    /*.container {*/
      /*width: 1300px;*/
    /*}*/
  /*}*/

  @media (max-width: 768px) {
    .content .content-left {
      /*min-height: 500px;*/
    }
    .top .top-left span {
      font-size: 20px;
    }

    .top .top-right ul {
      margin: 0;
      padding: 0;
    }

    .top ul li {
      font-size: 16px;
    }
  }

  @media (max-width: 767px) {
    .top .top-left {
      padding-bottom: 0px;
    }

    .top .top-right {
      padding: 0px;
      display: inline-block;
      text-align: center;
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/contentTemplate.vue